import { getFirestore } from "redux-firestore";

export const createTask = (task) => {
  return (dispatch, getState, { getFireBase, getFirestore }) => {
    //do stuff
    const firestore = getFirestore();
    const first = getState().firebase.profile.firstName;
    const last = getState().firebase.profile.lastName;
    const auth = getState().firebase.auth.uid;

    firestore
      .collection("tasks")
      .add({
        firstName: first,
        lastName: last,
        id: auth,
        date: new Date(),
        ...task,
      })
      .then(() => {
        // this takes a callback function
        dispatch({
          type: "CREATE_TASK",
          task: task,
        });
      })
      .catch((err) => {
        dispatch({ type: "NEW_TASK_ERROR", err });
      });
  };
};
